module.exports = __webpack_public_path__ + "static/media/bashkia-tirane-logo.9793e966.svg";